import {ReactComponent as Icon1} from '../../../Assets/Icons/desktopI1.svg';
import {ReactComponent as Icon2} from '../../../Assets/Icons/desktopI2.svg';
import {ReactComponent as Icon3} from '../../../Assets/Icons/desktopI3.svg';

import {ReactComponent as Icon4} from '../../../Assets/Icons/desktopI4.svg';
import {ReactComponent as Icon5} from '../../../Assets/Icons/desktopI5.svg';
import {ReactComponent as Icon6} from '../../../Assets/Icons/desktopI6.svg';
export const list1 = [
    {
        icon:<Icon1 />,
        title:"Take photos of sketches"
    },
    {
        icon:<Icon2 />,
        title:"Build prototypes"
    },
    {
        icon:<Icon3 />,
        title:"Offline Prototypes"
    }
]
export const list2 = [
    {
        icon:<Icon4 />,
        title:"Take photos of sketches"
    },
    {
        icon:<Icon5 />,
        title:"Build prototypes"
    },
    {
        icon:<Icon6 />,
        title:"Offline Prototypes"
    }
]
